<template>
    <li class="p-4 hover:bg-gray-100" :class="{'bg-gray-100': expanded}" >
        <div class="flex items-center justify-between">
            <div>
                <div class="font-semibold text-gray-800" >{{ areal.properties.navn }}</div>
            </div>
            <div>
                <button
                    @click.prevent="expanded = !expanded"
                    :title="'Se detaljer for ' + areal.properties.navn"
                    class="text-xs h-8 bg-blue-100 text-aak-blue rounded py-1 px-2 ml-2 font-semibold"
                >{{ expanded ? 'Skjul' : 'Detaljer' }}</button>
            </div>
        </div>
        <ArealBookingDetailsVue :areal="areal" v-if="expanded" />
    </li>
</template>

<script>
import ArealBookingDetailsVue from "./ArealBookingDetails.vue";
export default {
    name: "ArealBookings",
    components: {
        ArealBookingDetailsVue
    },
    props: ["areal"],
    data() {
        return {
            expanded: false
        }
    }
}
</script>